<script setup lang="ts">
import { ref } from 'vue';
import { LogIn } from 'lucide-vue-next';
import { useAuth } from '@/composables/useAuth';
import { useNavigation } from '@/composables/useNavigation';

const { navigate } = useNavigation();
const { authError, forgotPassword, isLoading, login, user } = useAuth();

const email = ref('');
const password = ref('');
const notice = ref('');
const localError = ref('');

async function submitLogin() {
  localError.value = '';
  notice.value = '';
  const ok = await login({ email: email.value, password: password.value });
  if (ok) navigate(user.value?.role === 'admin' ? 'admin' : 'family');
}

async function submitForgotPassword() {
  localError.value = '';
  notice.value = '';
  if (!email.value) {
    localError.value = 'Bitte gib zuerst deine E-Mail ein.';
    return;
  }
  await forgotPassword(email.value);
  notice.value = 'Wenn ein Konto existiert, wird ein Link zum Zuruecksetzen vorbereitet.';
}
</script>

<template>
  <section class="mx-auto grid max-w-5xl gap-8 px-4 py-10 md:grid-cols-[1fr_1.1fr] md:px-6">
    <div class="self-center">
      <h1 class="text-4xl font-black text-heart-berry md:text-6xl">Freundedorf</h1>
      <p class="mt-4 max-w-md text-lg font-semibold leading-8 text-heart-ink">
        Freundedorf – Hier wohnen Freundschaften ❤️
      </p>
    </div>
    <form class="rounded-[30px] bg-white p-6 shadow-soft md:p-8" @submit.prevent="submitLogin">
      <label class="block text-sm font-black text-heart-ink" for="email">E-Mail</label>
      <input id="email" v-model="email" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" type="email" autocomplete="email" required />
      <label class="mt-5 block text-sm font-black text-heart-ink" for="password">Passwort</label>
      <input id="password" v-model="password" class="focus-ring mt-2 min-h-14 w-full rounded-2xl border border-orange-100 px-4" type="password" autocomplete="current-password" required />
      <div class="mt-5 flex flex-wrap items-center justify-between gap-3">
        <label class="inline-flex items-center gap-3 text-sm font-bold text-heart-ink">
          <input class="h-5 w-5 rounded border-orange-200 text-heart-coral" type="checkbox" />
          Angemeldet bleiben
        </label>
        <button class="focus-ring rounded-full px-2 py-2 text-sm font-black text-heart-berry" type="button" @click="submitForgotPassword">
          Passwort vergessen
        </button>
      </div>
      <p v-if="localError || authError" class="mt-5 rounded-2xl bg-rose-100 px-4 py-3 font-bold text-rose-800">
        {{ localError || authError }}
      </p>
      <p v-if="notice" class="mt-5 rounded-2xl bg-heart-mint px-4 py-3 font-bold text-heart-leaf">
        {{ notice }}
      </p>
      <button
        class="focus-ring mt-8 inline-flex min-h-14 w-full items-center justify-center gap-3 rounded-2xl bg-heart-coral px-5 text-lg font-black text-white disabled:opacity-60"
        type="submit"
        :disabled="isLoading"
      >
        <LogIn class="h-6 w-6" aria-hidden="true" />
        Anmelden
      </button>
      <button class="focus-ring mt-4 w-full rounded-2xl px-5 py-4 font-black text-heart-berry" type="button" @click="navigate('register')">
        Familienkonto erstellen
      </button>
    </form>
  </section>
</template>
